<template>

	<v-dialog v-model="AppStore.toggleCGU" :fullscreen="true"
	          :hide-overlay="true" scrollable
	          no-click-animation>
		<v-card>
			<v-toolbar :max-height="$vuetify.breakpoint.mdAndUp ? 64 : 56" class="px-1 px-sm-5">
				<v-toolbar-title class="pl-0"><b>{{ $t('views.cgu.title') }}</b></v-toolbar-title>
				<div class="flex-grow-1"></div>
				<v-toolbar-items>
					<v-btn icon @click="AppStore.toggleCGU = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>

			<div class="pa-5 pa-sm-10" style="backface-visibility: hidden;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    overflow-y: auto;">
				<div v-html="AppStore.data.configuration[AppStore.locale].cgu_content"></div>
				<div class="text-center">
					<v-btn @click="AppStore.toggleCGU = false" role="link" rounded
					       elevation="0" dark
					       :large="AppStore.data.general.button_size === 'large'"
					       :x-large="AppStore.data.general.button_size === 'x-large'"
					       :x-small="AppStore.data.general.button_size === 'x-small'"
					       :small="AppStore.data.general.button_size === 'small'"
					       @keypress.enter="navigate"
					       class="text-button mt-3"
					       :style="Helpers.getButtonSize(AppStore.data.general.button_size)"
					       :color="AppStore.data.general.primary_color.hexa"
					       v-html="AppStore.data.configuration[AppStore.locale].cgu_close_btn">
					</v-btn>
				</div>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import AppStore from "../../stores/AppStore";
import Helpers from "../../services/Helpers";

export default {
	name: 'cgu-modal',

	props: {},

	components: {},

	data: () => ({
		AppStore,
		Helpers
	}),

	created() {
	},

	mounted() {

	},

	computed: {},

	watch: {},

	methods: {},
};
</script>
